'use client'
import Error from '@/components/ui/error'

export default Error
